/**
 * `useTheme()` hook — Story 5.2.
 *
 * Returns the current `ThemeContextValue`. Unlike Story 1.9's `useAuth()`,
 * this hook THROWS when called outside `<ThemeProvider>` (Critical Scope
 * Decision #8 in the story spec). Reasoning: every surface in this app
 * eventually wraps in `ThemeProvider`, so a null check at every call site
 * would be dead code; throwing gives a clearer dev-time error than a silent
 * null deref later.
 */
import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';
import type { ThemeContextValue } from './ThemeContext';

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be called within a ThemeProvider');
  }
  return ctx;
}
